// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--2ZuUN","container--active":"a10a3f92e9--container--active--1l6BG","aside_banner":"a10a3f92e9--aside_banner--2XkI0"};